import React from "react";
import { useTranslation } from "react-i18next";
import { qoriaColours } from "@/theme/colours";
import { SlidingToggle } from "../SlidingToggle";

interface Props {
	value: boolean;
	onChange: (enabled: boolean) => void;
	/** Renders a smaller, compact variant used inside a rule row. */
	size?: "md" | "sm";
	isDisabled?: boolean;
}

/**
 * Segmented "On" / "Off" toggle shown in place of Block/Allow for schools configured with
 * `create_blocking_rules_only`, where every rule is a block rule and the only choice a teacher
 * has is whether it currently applies.
 */
export function OnOffToggle(props: Props): JSX.Element {
	const { t } = useTranslation();
	const { value, onChange, size = "md", isDisabled = false } = props;

	return (
		<SlidingToggle
			size={size}
			isDisabled={isDisabled}
			selectedIndex={value ? 0 : 1}
			options={[
				{
					label: t("rulesLibrary.form.on"),
					icon: "fa-ban",
					activeBg: qoriaColours.brand.danger[10],
					activeColour: qoriaColours.brand.danger[500],
					onSelect: () => onChange(true),
				},
				{
					label: t("rulesLibrary.form.off"),
					icon: "fa-circle-minus",
					activeBg: qoriaColours.brand.neutral[100],
					activeColour: qoriaColours.brand.neutral[600],
					onSelect: () => onChange(false),
				},
			]}
		/>
	);
}
